<template>
  <main-layout>
    <div class="row first-row-about-resource first-row-resource">
      <div class="col-12 col-md-12 col-lg-12">
        <div class="row d-md-flex mt-3" />
        <div class="row d-md-flex mt-5" />
        <div class="row d-xl-flex mt-5" />
        <div class="row mt-1 mt-sm-5">
          <div class="col-sm-1 col-md-2" />
          <div class="col-sm-10 col-md-8">
            <div class="row" />
            <div class="row title-about-resource">
              <h2 class="white bold w-100 d-block d-md-none title-section">
                FUENTE DE DATOS
              </h2>
              <h1 class="white bold w-100 d-none d-md-block title-section">
                FUENTE DE DATOS
              </h1>
            </div>
            <div class="row body-about-resource">
              <p class="white w-100 subtitle-section">
                <br>El objetivo de esta página web es entregar a los estudiantes dominicanos y sus familias información confiable sobre la oferta de educación superior del país. Las cifras mostradas en esta página provienen del Data-Lab del Ministerio de Economía, Planificación y Desarrollo. J-PAL LAC tiene pleno acceso a esta información en razón de un convenio firmado por ambas partes.
              </p>
            </div>
          </div>
          <div class="col-sm-1 col-md-2" />
        </div>
      </div>
      <!-- <div class="col-1 col-md-2 col-lg-3" /> -->
    </div>

    <div class="row white-background">
      <div class="col-12 col-sm-8 p-2 p-xl-2">
        <div class="about-resource-div about-div px-2 px-sm-4 py-2 py-sm-5">
          <p class="dark-gray text-style-resource">
            <b style="font-weight: bold;">Programas de Educación Superior:</b> <br>
            La oferta de programas activos actualmente en la República Dominicana
            se obtuvo consultando la oferta de carreras que dispone cada institución
            en su página web; cuando la información no estaba disponible se recogió a
            través de llamadas telefónicas entre Abril-Junio del 2019.
          </p>
          <p class="dark-gray text-style-resource">
            <b style="font-weight: bold;">Categoría de carreras:</b> <br>
            Se presenta la información a nivel de las categorías de carreras usada por
            el Ministerio de Educación Superior, Ciencia y Tecnología (MESCyT). Además,
            con el fin de presentar información más precisa, se ha dividido cada categoría
            entre Licenciaturas y carreras Técnico Superior.
          </p>
          <p class="dark-gray text-style-resource">
            <b style="font-weight: bold;">Salarios:</b> <br>
            La información de salarios ha sido construida a partir del registro de los
            salarios de los egresados reportados en la Tesorería de Seguridad Social;
            por lo tanto, representan sólo al sector formal del mercado de trabajo. <br> <br>

            <b style="font-weight: bold;">a.</b> Se consideran sólo a los egresados de universidades
            que han reportado información de sus egresados. <br>
            <b style="font-weight: bold;">b.</b> Se consideran sólo los egresados empleados con
            salarios por sobre el mínimo (utilizamos el salario mínimo del sector económico con
            menor salario mínimo).
          </p>
          <p class="dark-gray text-style-resource">
            <b style="font-weight: bold;">Empleo:</b> <br>
            La información sobre el nivel de empleo ha sido construida a partir de los
            salarios de los egresados reportados en la Tesorería de Seguridad Social;
            por lo tanto, representan sólo al sector formal del mercado de trabajo.
          </p>
          <p class="dark-gray text-style-resource">
            <b style="font-weight: bold;">Pruebas Nacionales:</b> <br>
            La información de Pruebas Nacionales ha sido provista por el Departamento
            de Evaluación de Calidad Educativa del Ministerio de Educación.
          </p>
          <p class="dark-gray text-style-resource">
            <b style="font-weight: bold;">PENSUM:</b> <br>
            La información de los planes de estudios o pensum fue recopilada a partir
            de los pensum reportados por cada institución de Educación Superior en sus página
            web o en visitas a las universidades. Estos documentos fueron digitalizados y
            categorizados por el equipo de investigadores que participaron en el desarrollo
            de la plataforma.
          </p>
          <p class="dark-gray text-style-resource">
            <b style="font-weight: bold;">Costos y duración por carrera:</b> <br>
            La información de costos y duración de cada fue recolectada por el equipo de
            investigadores que participaron en el desarrollo de la plataforma, a partir de
            las páginas web de las instituciones o a través del Departamento de Admisión
            de las mismas.
          </p>
          <p class="dark-gray text-style-resource">
            <b style="font-weight: bold;">Información de contacto de cada Institución:</b> <br>
            La ubicación e información de contacto de cada institución fue recolectada por
            el equipo de investigadores asociado al proyecto.
          </p>
          <!-- <p class="white">
            <b>Descargar detalle de cómo construímos los estadísticos.</b>
          </p> -->
          <p class="white cyan text-style-advicenote">
            <font>
              <b>
                Si perteneces a alguna institución de Educación Superior y has notado que contamos
                con información desactualizada, déjanos saber a <a
                  href="mailto:info@consiliumbots.com?Subject=Contacto"
                  target="_top"
                ><i style="color: #ffffff;">info@consiliumbots.com</i></a>
                ¡Lo arreglaremos lo antes posible!
              </b>
            </font>
          </p>
          <p class="dark-gray text-style-footnote">
            <br>
            <br>
            <font>
              Los datos presentados en esta plataforma fueron consolidados por el DataLab
              del Ministerio de la Presidencia y analizados en conjunto con el equipo de
              investigadores de ConsiliumBots y J-PAL LAC a través de acuerdos de confidencialidad.
            </font>
          </p>
        </div>
      </div>
      <div class="col-12 col-sm-4 p-2 p-xl-2">
        <div style="justify-content: center;">
          <div class="about-resource-div">
            <img
              class="image-about-resource"
              src="@/assets/img/MEPDyDATA_Mesa_de_trabajo.png"
            >
          </div>
        </div>
        <div style="justify-content: center;">
          <div class="about-resource-div">
            <img
              class="image-about-resource"
              src="@/assets/img/consiliumLogo.png"
            >
          </div>
        </div>
        <div style="justify-content: center;">
          <div class="about-resource-div">
            <img
              class="image-about-resource-presidence"
              src="@/assets/img/image2.png"
            >
          </div>
        </div>
        <div style="justify-content: center;">
          <div class="about-resource-div">
            <img
              class="image-about-resource-bitmap"
              src="@/assets/img/Bitmap_2.png"
            >
          </div>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>

export default {
    name: 'DataSource',
    components: {},
    data() {
        return {};
    },
    methods: {
    },
};
</script>

<style lang="scss">
.dark-gray {
    color:#333333;
}

.title-section {
    font-weight: bold;
    font-size: 28px;
}

.subtitle-section {
    font-size: 20px;
    font-weight: bold;
    line-height: 24px;
}

.first-row-resource {
  background-image: url('../assets/img/pcCofee.png');
  min-height: 420px;
}
.title-resource {
    margin-top: -110px !important;
}
.body-resource {
  margin-top: -30px !important;
}
.first-row-resource > p {
  font-size: 20px;
  margin-right: 150px;
  margin-left: 150px;
}
.resource-yellow {
  height: 100%;
  background-color: #F0D000;
}
.text-style-resource {
    line-height: 27px;
    font-size: 23px;
    margin-left: 5%;
    margin-right: 8%;
    padding-bottom: 5%;
    font-weight: 300;
    //text-align: justify;
}
.text-style-footnote {
    font-size: 14px;
    padding-left: 3%;
    font-weight: 300;
    line-height: 16px;
    //text-align: justify;
}
.text-style-advicenote {
    font-size: 20px;
    padding: 2%;
    padding-right: 5%;
    margin-left: 3%;
    //text-align: justify;
}
.image-about-resource-presidence {
    margin-left: auto;
    margin-right: auto;
    display: block;
    height: 3.5vw;
}
.image-about-resource-bitmap {
    margin-left: auto;
    margin-right: auto;
    display: block;
    height: 7vw;
}

@media (max-width: 600px) {
    .text-style-resource {
        font-size: 15px;
        margin-left: 5%;
        margin-right: 8%;
        padding-bottom: 5%;
        //text-align: justify;
    }
    .text-style-footnote {
        font-size: 10px;
        padding-left: 3%;
        //text-align: justify;
    }
    .text-style-advicenote {
        font-size: 13px;
        padding: 2%;
        padding-right: 5%;
        margin-left: 3%;
        font-weight: bold;
        line-height: 27px;
        //text-align: justify;
    }
}
@media (max-width: 575px) {
    .image-about-resource-presidence {
        margin-left: auto;
        margin-right: auto;
        display: block;
        height: 8vw;
    }
    .image-about-resource-bitmap {
        margin-left: auto;
        margin-right: auto;
        display: block;
        height: 10vw;
    }
    .subtitle-section {
        font-size: 13px;
        font-weight: bold;
        line-height: 24px;
    }
}
</style>
